import { useMutation } from 'query';
import { handleAxiosError } from 'ui';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { deleteEventAttachment } from '../../services';

const defaultMutateOnError = (error: ApiClientResponseError<ResponseErrorDataObject>) => {
  handleAxiosError(error, 'Event attachments cannot be deleted, please try again later.');
};

type DeleteEventAttachmentParams = {
  attachmentId: string;
  eventId: string;
};

export const useDeleteEventAttachmentMutation = () =>
  useMutation<unknown, DeleteEventAttachmentParams>({
    defaultMutateOnError,
    async mutationFn({ attachmentId, eventId }) {
      await deleteEventAttachment({
        routeParams: { attachmentId, eventId },
      });
    },
  });
